import React, { useEffect, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";

// --- Link Your Real Project Files ---
// 1. Link your actual useAuth hook from your AuthProvider.
import { useAuth } from "../Hooks/AuthProvider"; 

// 2. Link your SignInForm component.
import SignInForm from "../Components/SignInForm";
import LoadingSpinner from "../Components/LoadingSpinner";
import { isGoogleOAuthInProgress } from "../Utils/pendingGoogleOAuth";

// 3. Link your logo image.
import logo from "../img/logo.png";

// 4. Link your CSS file.
import "./LogIn.css";
// --- End of Links ---

const LogIn = () => {
  // This now uses your REAL useAuth hook from the AuthProvider
  const { user, loading, onLogin, isCompletingGoogleSignIn } = useAuth();
  const [loginWithEmail, setLoginWithEmail] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const removePopup = (e) => {
      if (e.target.id === "login-container" || e.key === 'Escape') {
        setLoginWithEmail(false);
      }
    };
    document.addEventListener("mousedown", removePopup);
    document.addEventListener("keydown", removePopup);
    return () => {
      document.removeEventListener("mousedown", removePopup);
      document.removeEventListener("keydown", removePopup);
    };
  }, []);

  // --- THE CRUCIAL FIX ---

  // 1. First, check if the AuthProvider is still loading.
  //    If it is, we wait by rendering a loading message. This prevents premature redirects.
  if (loading) {
    console.log('[LogIn Page] Auth provider is loading. Waiting...');
    return <LoadingSpinner />;
  }

  const oauthSignInPending =
    isCompletingGoogleSignIn || isGoogleOAuthInProgress();

  if (!user && oauthSignInPending) {
    const from = location.state?.from?.pathname || "/calendar";
    return <Navigate to={from} replace />;
  }

  // 2. After loading is finished, check if a user exists.
  if (user) {
    const from = location.state?.from?.pathname || "/calendar";
    console.log(`[LogIn Page] Auth loaded and user exists. Redirecting to "${from}".`);
    return <Navigate to={from} replace />;
  }
  
  // 3. If loading is done and there's no user, render the real login UI.
  console.log('[LogIn Page] Auth loaded, no user. Rendering login buttons.');
  return (
    <div id="login-container">
      <img className="welcome-image" alt="Logo" src={logo}></img>
      <h1 className="buttons">
        <button className="login-with-google-btn" onClick={onLogin}>
          Log in with Google
        </button>
        <button
          className="login-with-email-btn"
          onClick={() => setLoginWithEmail(true)}
        >
          Log in with email
        </button>
      </h1>
      {loginWithEmail ? <SignInForm onExitPopup={setLoginWithEmail} /> : null}
    </div>
  );
};

export default LogIn;

